import React, { useEffect, useState } from "react"

import IconPlus from './icon-plus'
import IconMinus from './icon-minus'
import { convertPersianDigits } from "../utils/convertDigits"

const Stepper = (props) => {
	const { title, unit, min, max, value, placeholder } = props
	const [InputValue, setInputValue] = useState(value || '')


	const handleChangeInput = (e) => {
		let converted = convertPersianDigits(e.target.value)
		setInputValue(converted)
	}

	useEffect(() => {
		if (!value) {
			setInputValue('')
		}
	}, [value])

	const handleChangePlus = () => {
		if (InputValue) {
			if (InputValue < max) {
				setInputValue(Number(InputValue) + 1)
			}
		} else {
			setInputValue(Number(min) + 1)
		}
	}

	const handleChangeMinus = () => {
		if (InputValue) {
			if (InputValue > min) {
				setInputValue(Number(InputValue) - 1)
			}
		} else {
			setInputValue(Number(max) - 1)
		}
	}

	useEffect(() => {
		if (InputValue) {
			props.change(InputValue)
		}
	}, [InputValue])


	return <>
		<div className="stepper">
			<div className="display_flex justify_content_center align_items_center title">
				<label>{title}&nbsp;</label>
				<small>({unit})</small>
			</div>
			<div className="value_wrapper">
				<input type="number" value={InputValue}
					onChange={(e) => handleChangeInput(e)}
					className="value"
					placeholder={placeholder}
				/>
			</div>

			<div className="buttons">
				<button
					onClick={() => handleChangePlus()}
				><IconPlus /></button>
				<button
					onClick={() => handleChangeMinus()}
				><IconMinus /></button>
			</div>
		</div>
	</>
}
export default Stepper